import { handleBonusNotificationInfo } from '../common/handleBonusNotificationInfo';

export const bonusNoConfirmationNotification = ({ data: actionInfo }, { lang, syncClose, dispatch }) =>
    handleBonusNotificationInfo({ actionInfo, isConfirmation: false }, { lang, syncClose, dispatch });
